// extracted by mini-css-extract-plugin
export default {"widgetContainer":"StandardWrapper_widgetContainer__Ep7Vb"};